<template>
  <div class="area" @click="clickEvent">
    <div class="bar"></div>
    <div class="bar"></div>
  </div>
</template>

<script>
export default {
  methods: {
    clickEvent() {
      this.$emit('handleClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.area {
  cursor: pointer;
  .bar {
    background-color: $mainColor;
    width: 30px;
    height: 2px;
    &:nth-child(1) {
      transform: rotate(45deg);
    }
    &:nth-child(2) {
      transform: rotate(-45deg);
      margin-top: -2px;
    }
  }
}
</style>
